import React, { Component } from "react";
import { FormGroup, Nav, NavItem, Button } from "reactstrap";
import { Link, Route, Switch } from "react-router-dom";
import PropTypes from "prop-types";
import {
	AppNavbarBrand,
	AppSidebarToggler,
	AppSidebarHeader,
} from "@coreui/react";
import Popover from "@material-ui/core/Popover";
import logo from "../../assets/img/brand/logo.png";
import logoMin from "../../assets/img/brand/logoMin.png";
import navigation from "../../_nav";
import { LoadingLogo } from "../../components/loading/loading-logo";
import Tour from "reactour";


/* these will be used for creating a connection with graphql server */

import APIClient from "../../components/ApolloClientComponent/ApolloClient";
import gql from "graphql-tag";

/* end graphql stuff */

import Fire from "../../components/firebase/Fire";

import {companyInformationStatus$} from "../../views/company-information/company-information";
import moment from "moment";


const propTypes = {
	children: PropTypes.node
};

const defaultProps = {};

class Header extends Component {
	constructor(props) {
		super(props);

		this.state = {
			notifications: [],
			lastIndex: 9,
			jobs: [],
			navigation: navigation,
			isLoadingProfile: true,
			isImageLoading: true,
			anchorEl: null,
			profile: {
				name: "",
				img: ""
			},
			isTourOpen:false,
			userSubscriptionType: null,
			daysLeftInTrial:null,
		};

		this.loadProfileDetails = this.loadProfileDetails.bind(this);
		this.logout = this.logout.bind(this);
		this.changeWindowLocation = this.changeWindowLocation.bind(this);
		this.loadProfileDetails();
	}

	componentWillReceiveProps(nextProps){
		if(localStorage.getItem("settingsTour") === "true" && nextProps.startTourSettings){
			document.documentElement.style.zoom = 1.0;
		}
		if( localStorage.getItem("settingsTour") === "true"){
			this.setState({ isTourOpen: nextProps.startTourSettings });
		}
	}

	closeTour = () => {
		localStorage.setItem("settingsTour","false");
		document.documentElement.style.zoom = 0.8;
		this.setState(
			{
				isTourOpen: false,
			}
		);
	};

	logout() {

		Fire.auth().signOut().then(() => {
			companyInformationStatus$.next(true);
		});
		/**heap.io **reset identity** */
		window.heap.resetIdentity();
	}

	changeWindowLocation(){

		window.location.replace("/#/Settings/Branding?id=5");
	}

	handleMenuClick(event) {
		event.preventDefault();
		this.setState({ anchorEl: event.currentTarget });
	}

	handleMenuClose() {
		this.setState({ anchorEl: null });
	}

	loadProfileDetails() {
		const currentUserId = Fire.auth().currentUser.uid;

		return APIClient.query({
			fetchPolicy: "network-only",
			query: gql`
				query user($userId: ID!) {
					user(id: $userId) {
						id
						firstName
						lastName
						defaultValues
						subscriptionType
						expiryDate
					}
				}
			`,
			variables: {
				userId: currentUserId
			}
		}).then(({ data: { user } }) => {
			APIClient.query({
				fetchPolicy: "network-only",
				query: gql`
					query company($companyId: ID!) {
						company(id: $companyId) {
							id
							logoUrl
						}
					}
				`,
				variables: {
					companyId: user.defaultValues.company
				}
			}).then(({ data: { company } }) => {
				const name = user.firstName + " " + user.lastName;
				const img = company.logoUrl
					? company.logoUrl
					: "assets/img/avatars/generic.png";
				this.setState({
					userSubscriptionType: user.subscriptionType,
					profile: {
						name: name,
						img: img
					},
					isLoadingProfile: false
				});
				let daysLeftInTrial = user.expiryDate - moment().unix();
				daysLeftInTrial = (daysLeftInTrial/60/60/24 )-1;
				this.setState({
					daysLeftInTrial: daysLeftInTrial
				});
				
			});
		});
	}

	consumeNotification(item) {
		APIClient.mutate({
			mutation: gql(`
				mutation consumeNotification($id: ID!){
					consumeNotification(id: $id)
				}
			`),
			variables: {
				id: item.id
			}
		});
	}

	render() {
		let profileHeader;
		let profileMenu;
		const { isTourOpen } = this.state;
		const accentColor = "#FFFFFF";
		if (this.state.isLoadingProfile) {
			profileHeader = <LoadingLogo style={{ height: "100px" }} />;
			profileMenu = (
				<div data-tut="settings-detail">
					<span
						onClick={this.handleMenuClick.bind(this)}
						className="fas fa-user"
						style={{ fontSize: "24px", color: "#7C7C83" }}
					/>
					<span
						className="fa fa-angle-down"
						style={{
							fontSize: "16px",
							paddingLeft: "4px",
							paddingRight: "12px",
							color: "#7C7C83"
						}}
					/>
				</div>
			);
		} else {
			profileHeader = (
				<div className="sidebar-img">
					<div style={{ fontWeight: "bold", color: "#6E777B" }}>
						{this.state.profile.name}
					</div>
					<img
						src={this.state.profile.img}
						className="img-avatar prof-img"
						alt="Profile Img"
						style={{
							height: "24px",
							width: "24px"
						}}
					/>
				</div>
			);
			profileMenu = (
				<div style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",

				}}
				data-tut="settings-detail">
					<img
						style={{ height: "36px" }}
						src={this.state.profile.img}
						className="img-avatar prof-img"
					/>
					<span
						className="fa fa-angle-down"
						style={{
							fontSize: "16px",
							paddingLeft: "4px",
							paddingRight: "4px",
							color: "#7C7C83"
						}}
					/>
				</div>
			);
		}
		return (
			<React.Fragment>
				<Tour
					onRequestClose={this.closeTour}
					steps={tourConfig}
					isOpen={isTourOpen}
					maskClassName="mask"
					maskSpace={0}
					className="helper"
					rounded={5}
					accentColor={accentColor}
					showNumber={false}
					lastStepNextButton={<Button style={{color:"#8A5471", backgroundColor:"white", borderColor:"white",boxShadow:"none"}}>Got it!</Button>}
					nextButton={<Button style={{color:"white", backgroundColor:"#8A5471", borderColor:"#8A5471",boxShadow:"none"}}><i className="fas fa-arrow-right"></i></Button>}
					prevButton={<Button style={{color:"white", backgroundColor:"#8A5471", borderColor:"#8A5471",boxShadow:"none"}}><i className="fas fa-arrow-left"></i></Button>}
				/>
				<AppSidebarToggler className="d-lg-none" display="md" mobile />
				<AppNavbarBrand
					full={{
						src: logo,
						width: "auto",
						height: 32
					}}
					minimized={{
						src: logoMin,
						width: 30,
						height: 30
					}}
				/>
				<AppSidebarToggler className="d-md-down-none d-lg-none" display="lg" />

				<FormGroup className="d-md-down-none col-md-8">
					<div className="controls" />
				</FormGroup>

				<Nav className="ml-auto" navbar>
					{/* <NavItem>{this.state.notifications.length}</NavItem> */}
					{this.state.userSubscriptionType === 2 ? (
					
						<NavItem style={{paddingRight:"5px"}}>
							<button className="btn font-weight-bold" style={{color:"#FF7F00", borderColor:"#FFFFFF"}} onClick={this.changeWindowLocation}>
								{ Math.ceil(this.state.daysLeftInTrial)} days left in Trial
							</button>
						</NavItem>
					
					): null
				
					}
					
					<NavItem>
						<a href="https://talentscript.typeform.com/to/xSNoc0" target="_blank"><button className="btn  btn-purple font-weight-bold">Feedback</button></a>
					</NavItem>

					<NavItem className="cursor-pointer">
						<div

							style={{
								width:"80px",
							}}
							onClick={this.handleMenuClick.bind(this)}
						>
							{profileMenu}
						</div>
						<Popover
							open={Boolean(this.state.anchorEl)}
							anchorEl={this.state.anchorEl}
							onClose={this.handleMenuClose.bind(this)}
							className="header-popover-menu"
							anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
							transformOrigin={{ vertical: "top", horizontal: "center" }}
						>
							<div className="sidebars">
								<div className="scrollbar-container sidebar-nav ps ps-container">
									<ul className="nav">
										<li className="nav-item">
											<Link
												to="/home"
												style={{textDecoration: "none", color: "black"}}
											>
												<AppSidebarHeader children={profileHeader}/>
											</Link>
										</li>
										<li className="nav-item">
											<Link to={{
												pathname: "/settings/branding/",
												search: "?id=1"
											}} className="nav-link">Personal profile</Link>
										</li>
										<li className="nav-item">
											<Link to={{
												pathname: "/settings/branding/",
												search: "?id=2"
											}}
											className="nav-link"
											>
												Company profile
											</Link>
										</li>
										<li className="nav-item">
											<Link to={{
												pathname: "/settings/branding/",
												search: "?id=3"
											}}
											className="nav-link"
											>
												Branding preferences
											</Link>
										</li>

										{/* <li className="nav-item">
											<Link to={{
												pathname: "/settings/branding/",
												search: '?id=4'
											}}
											className="nav-link"
											>
												Invoices
											</Link>
										</li> */}

										<li className="nav-item">
											<Link to={{
												pathname: "/settings/branding/",
												search: "?id=5"
											}}
											className="nav-link"
											>
												Subscriptions
											</Link>
										</li>

										<li className="nav-item logout">
											<a
												href=""
												onClick={this.logout}
												className="nav-link logout"
											>
												Logout
											</a>
										</li>
									</ul>
								</div>
							</div>
						</Popover>
					</NavItem>

					{/*
					<NavItem className="d-md-down-none">
						<NavLink>
							<NotificationManager
								notifications={this.state.notifications.filter(
									(notification, index) => index <= this.state.lastIndex
								)}
								notificationTitle={"Notification Center"}
								onItemClick={item => this.consumeNotification(item)}
								noNotificationText={"There are no notifications"}
								onScrollBottom={() => this.loadNotificationsChunk()}
								lastIndex={this.state.lastIndex}
							/>
						</NavLink>
					</NavItem> */}
				</Nav>
				{/*
				<AppAsideToggler
					children={
						<span
							className="ci ci-settings"
							style={{ fontSize: "24px", color: "#7C7C83" }}
						/>
					}
					className="d-lg-none"
					display="medium"
				/>
				<AppAsideToggler
					children={
						<span
							className="ci ci-settings"
							style={{ fontSize: "24px", color: "#7C7C83" }}
						/>
					}
					className="d-md-down-none"
					style={{ outline: "none" }}
				/> */}
			</React.Fragment>
		);
	}
}

const tourConfig = [
	{
		selector: "[data-tut=\"settings-detail\"]",
		content: () => (
			<div>
				<h3>Settings</h3>
				<p style={{fontSize:"16px"}}>Set your profile settings here - and your branding too!</p>
			</div>

		),
		style: {
			backgroundColor: "#8A5471",
			color: "white",
		}
	}
];
Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
